import { Component } from '@angular/core';
import { TeamsService } from '../../shared/services/teams.service';
import { Data } from './types/teams.type';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidateFormService } from '../../shared/services/validate-form.service';
import { ToastrService } from 'ngx-toastr';
import { positiveNumberValidator } from '../../shared/validators/positive-number.validator';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrl: './teams.component.scss',
})
export class TeamsComponent {
  teams: Data[] = [];
  selectedTeam: any;
  public form: FormGroup = new FormGroup({
    team: new FormControl('', [Validators.required]),
    points: new FormControl('', [
      Validators.required,
      positiveNumberValidator(),
    ]),
  });

  constructor(
    private _teams: TeamsService,
    private validateService: ValidateFormService,
    private _tostr: ToastrService
  ) {}

  ngOnInit() {
    this.getTeams();
  }

  getTeams() {
    this._teams.getTeams().subscribe({
      next: (response) => {
        this.teams = response.data;
      },
      error: (error) => {
        console.log('Error: ', error);
      },
    });
  }
  patchTeamPoints(team: any) {
    this.selectedTeam = team;
    this.form.patchValue({
      points: team.points,
    });
  }
  updatePoints() {
    if (this.form.invalid) {
      return this.validateService.validateAllFormFields(this.form);
    }
    const data = {
      points: parseInt(this.form.value.points),
      name: this.selectedTeam.name,
      color: this.selectedTeam.color,
      playersNo: this.selectedTeam.playersNo,
    };
    this._teams.updatePoints(data, this.selectedTeam._id).subscribe({
      next: (response) => {
        this.getTeams();
        this.form.reset();
        this._tostr.success('تم تحديث النقاط بنجاح');
      },
      error: (error) => {
        console.log('Error: ', error);
      },
    });
  }
}
